import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PartBuilder } from '../../models/builders/part.builder';
import { Print } from '../../models/print';
import { Source } from '../../models/source';
import { Part } from '../../models/part';
import { ErpTaskBuilder } from '../../models/builders/erp-task.builder';

const partBody = (part: Part) => ({
  name: part.name,
  erpTask: part.erpTask
});

@Injectable()
export class PartApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }parts`;
  }

  getFilteredPartsNoParams() {
    return this.getFilteredParts();
  }

  getPartsByPrintAndSource(print: Print, source: Source) {
    const params = new HttpParams()
      .append('print', print.hash)
      .append('source', source.hash);

    return this.getFilteredParts(params);
  }

  private getFilteredParts(params?: HttpParams) {
    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(
        map(PartBuilder.fromList)
      );
  }

  createPart(part) {
    return this.httpClient.post(this.apiUrl, partBody(part)).pipe(map(PartBuilder.fromJson));
  }

  deletePart(part: Part) {
    return this.httpClient.delete(`${ this.apiUrl }/${ part.hash }`);
  }

  getParts() {
    return this.httpClient.get(`${ this.apiUrl }/parts`).pipe(map(PartBuilder.fromList));
  }

  getPart(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(PartBuilder.fromJson));
  }

  updatePart(part: Part) {
    return this.httpClient.put(`${ this.apiUrl }/${ part.hash }`, partBody(part));
  }

  getErpTasks() {
    return this.httpClient.get(`${ this.apiUrl }/erp-tasks`).pipe(map(ErpTaskBuilder.fromList));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/part-api.service.ts